import { defineMessages } from "@/i18n";
import en from "./en";

export const toastsMessages = defineMessages("toasts", en);
